module.exports = __webpack_public_path__ + "img/square-gold-logo-small.f433d2c3.png";